function headerSearchInit() {
	const headerSearch = document.querySelector("#headerSearch");
	if (headerSearch) {
		headerSearch.addEventListener("input", function(event) {
			this.className = event.target.value.length > 0 ? "field-has-content" : "";
		});
	}
}
